var map = {
	"./application.js": "./src/api/modules/application.js",
	"./client.js": "./src/api/modules/client.js",
	"./commodity.js": "./src/api/modules/commodity.js",
	"./configuration.js": "./src/api/modules/configuration.js",
	"./customer.js": "./src/api/modules/customer.js",
	"./employee.js": "./src/api/modules/employee.js",
	"./equipment.js": "./src/api/modules/equipment.js",
	"./index.js": "./src/api/modules/index.js",
	"./internet.js": "./src/api/modules/internet.js",
	"./notification.js": "./src/api/modules/notification.js",
	"./role.js": "./src/api/modules/role.js",
	"./staff.js": "./src/api/modules/staff.js",
	"./user.js": "./src/api/modules/user.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api/modules sync \\.js$";